.carousel {
  position: relative;
}

.viewport {
  overflow: hidden;
  touch-action: pan-y;
}

.track {
  display: flex;
  transition: transform 0.3s ease;
  width: 100%;
}

.slide {
  width: 100%;
  height: 240px;
  flex: 0 0 100%;
}

.slideImg {
  max-width: 100%;
  width: 100%;
  user-select: none;
}

.stepper {
  background: none;
  justify-content: center;
}
